import React from 'react';
import { ReactComponent as Close } from '../../svg/close.svg';
import { cartIncludedProductsSelector } from '../../redux/selectors/cartSelector';
import { connect } from 'react-redux';
import { ID_ANTI_SPAM, ID_SITE_SECURITY } from "../../constants/constants";

function ExtraPackageDetails({
    setModalOpened,
    list,
    setExtraChecked,
    product_id,
    includedProducts,
}) {
    return (
        <div className={'form__container width--710 pt-16'}>
            <h3 className={'mb-16'}>Confirmation</h3>
            {includedProducts?.length > 1 ? (
                <div className={'lists'}>
                    {includedProducts
                        // Products only having extra packages.
                        ?.filter((product) => [1, 4].includes(product.product_id))
                        .map((product) => (
                            <div>
                                <h4>{product?.product_name}</h4>
                                <ul className={'list list--small-space text--left text'}>
                                    {product?.extra_package_description_items?.map((item, i) => (
                                        <li
                                            key={
                                                'extra-package-description-' + product_id + '-' + i
                                            }
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                </div>
            ) : (
                <ul className={'list  list--small-space text--left text'}>
                    {list.map((item, i) => (
                        <li key={'extra-package-description-' + product_id + '-' + i}>{item}</li>
                    ))}
                </ul>
            )}
            <div className={'section--alert mt-28'}>
                Are you sure you want to cancel these features?
            </div>
            <div className={'form__row pt-28'}>
                <button
                    type="button"
                    className="button button--bg-blue button--bordered b-radius mr-28 tablet-mr-0 tablet-mb-16"
                    onClick={() => setModalOpened(false)}
                >
                    <span className="text-3 l-spacing color--white">No</span>
                </button>
                <button
                    type="button"
                    className="button button--bg-white button--bordered b-radius"
                    onClick={() => {
                        setModalOpened(false);
                        setExtraChecked({ value: false, includedIds: [ID_ANTI_SPAM, ID_SITE_SECURITY] });
                    }}
                >
                    <span className="text-3 l-spacing color--blue-2">Yes</span>
                </button>
            </div>
            <button
                type={'button'}
                className={'button--reset modal__close size-24'}
                onClick={() => setModalOpened(false)}
            >
                <span className={'visually-hidden'}>Close Modal</span>
                <Close className={'icon size-12'} />
            </button>
        </div>
    );
}

const mapStateToProps = (state) => ({
    includedProducts: cartIncludedProductsSelector(state),
});

export default connect(mapStateToProps, null)(ExtraPackageDetails);
